/*
 * Project: Dynamedics Portal Web
 * Created Date: Monday December 4th 2023
 * Author: KasunKarunasekara
 * -----
 * Last Modified: Monday December 4th 2023 6:03:26 pm
 * Modified By: KasunKarunasekara at <kkarunasekara@mitrai.com>
 * -----
 * Copyright (c) 2023 Mitra Sparks
 * -----
 * HISTORY:
 */

import { Box, List, Stack, useMediaQuery, useTheme } from '@material-ui/core';
import React, { useState } from 'react';
import Logo from 'src/components/shared/Logo';
import Scrollbar from 'src/components/shared/Scrollbar';
import { Link as RouterLink, useLocation, matchPath } from 'react-router-dom';
import NavbarConfig from './NavbarConfig';
import useAuth from 'src/hooks/useAuth';
import NavbarComponent from './NavbarComponent';

function reduceChild({ array, item, pathname, level, roles, isMobile }) {
  const key = item.href + level;
  if ((roles || []).includes(item.role)) {
    if (item.items?.length > 0) {
      const match = matchPath(pathname, {
        path: item.href,
        exact: false
      });

      return [
        ...array,
        <NavbarComponent
          key={key}
          level={level}
          icon={item.icon}
          info={item.info}
          href={item.href}
          title={item.title}
          open={Boolean(match)}
          isMobile={isMobile}
        >
          {/* {renderSidebarItems({
            pathname,
            level: level + 1,
            items: item.items,
            roles: roles,
            icon: item.icon
          })} */}
        </NavbarComponent>
      ];
    }

    return [
      ...array,
      <NavbarComponent
        key={key}
        level={level}
        href={item.href}
        icon={item.icon}
        info={item.info}
        title={item.title}
        isMobile={isMobile}
      />
    ];
  }
  return [...array];
}

function renderSidebarItems({ items, pathname, level = 0, roles, isMobile }) {
  return (
    <List
      component={Stack}
      direction={isMobile && 'row'}
      disablePadding
      sx={{ pl: 3, color: 'white' }}
    >
      {items.reduce(
        (array, item) =>
          reduceChild({ array, item, pathname, level, roles, isMobile }),
        []
      )}
    </List>
  );
}

export default function NavItems() {
  const theme = useTheme();
  const { user } = useAuth();
  const { pathname } = useLocation();
  const [bookmarks, setBookmarks] = useState([]);
  const [supplierEventsView, setSupplierEventsView] = useState({});
  const { MenuLinks } = NavbarConfig(bookmarks, supplierEventsView);
  const sectionLinks =
    MenuLinks?.filter((link) => link?.rolePrefix == 'insights_') || [];
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  const sidebarContent = (
    <Scrollbar>
      <Box sx={{ py: 3 }}>
        <RouterLink to="/dashboard">
          <Logo
            logo={'/static/brand/EX_EMB_DISC_OL_PETROL_RGB.png'}
            sx={{ m: '0 auto' }}
            height={35}
          />
        </RouterLink>
      </Box>
      {sectionLinks.map((list) => (
        <List
          sx={{ color: theme.palette.common.white }}
          disablePadding
          key={list.subheader}
        >
          {renderSidebarItems({
            items: list.items,
            roles: user.roles || [],
            pathname
          })}
        </List>
      ))}
    </Scrollbar>
  );

  const navBarContent = (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-end'
      }}
    >
      <Box
        sx={{
          // boxShadow:
          //   pathname == '/dashboard' && '0px 4px 3px rgba(0, 0, 0, 0.25)',
          // borderRadius: pathname == '/dashboard' && '8px',
          // backgroundColor:
          //   pathname == '/dashboard'
          //     ? theme.palette.primary.dark
          //     : theme.palette.primary.main,
          // borderRadius: '8px',
          background: 'transparent',
          position: 'relative',
          transition: 'transform 0.1s ease, box-shadow 0.05s ease',
          ':hover': {
            transform: 'scale(1.06) rotate(0deg)',
            mb: 0.5
          },
          ':active': {
            transform: 'scale(1) rotate(0)',
            mb: 0.5
          },
          mb: 0.5
        }}
      >
        <RouterLink to="/">
          <Logo
            logo={'/static/brand/EX_EMB_DISC_OL_PETROL_RGB.png'}
            sx={{ mb: 1.5 }}
            height={35}
          />
        </RouterLink>
      </Box>
      {sectionLinks.map((list) => (
        <List
          component={Stack}
          direction={isMobile && 'row'}
          sx={{ color: theme.palette.common.white }}
          disablePadding
          key={list.subheader}
        >
          {renderSidebarItems({
            items: list.items,
            roles: user.roles || [],
            pathname,
            isMobile
          })}
        </List>
      ))}
    </Box>
  );

  if (isMobile) {
    return sidebarContent;
  }
  return navBarContent;
}
